import React, { useCallback, useMemo } from 'react';
import { DataSetSecretSelector } from 'apps/sigma2-ui/src/data-wizard/components/DataSetSecretSelector';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToLeverApiAuthMethod } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';

export interface ConfigureWriteBackLeverApiAuthMethodProps
  extends ConfigureWorkflowBaseProps {
  authMethod: WriteBackToLeverApiAuthMethod | null;

  updateAuthMethod: (authMethod: WriteBackToLeverApiAuthMethod | null) => void;
}

export const ConfigureWriteBackLeverApiAuthMethod = ({
  authMethod,
  updateAuthMethod,
  listSecretsPattern,
  organizationId,
}: ConfigureWriteBackLeverApiAuthMethodProps) => {
  const updateSecretReference = useCallback(
    (secretReference: SecretReference | null) => {
      updateAuthMethod({
        type: 'api',
        ...authMethod,
        apiKeySecretReference: secretReference ?? undefined,
      });
    },
    [authMethod, updateAuthMethod],
  );

  const currentSecretReference = useMemo(
    () => authMethod?.apiKeySecretReference ?? null,
    [authMethod?.apiKeySecretReference],
  );

  return (
    <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold">Configure Lever API Auth Method</h2>
      <p className="text-gray-600">
        Select the API key secret for Lever integration.
      </p>
      <DataSetSecretSelector
        secretReference={currentSecretReference}
        setSecretReference={updateSecretReference}
        organizationId={organizationId}
        label="Select the API key secret"
        listSecretsPattern={listSecretsPattern}
      />
    </div>
  );
};
